import { Box, useTheme } from "@mui/material";
import React from "react";
import {
  CircleMarker,
  LayerGroup,
  MapContainer,
  TileLayer,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useConfig } from "../../api/api";

// Tiles are served by the FOSSGIS e.V. tile server (tile.openstreetmap.de).
// Terms of use: https://www.fossgis.de/arbeitsgruppen/osm-server/nutzungsbedingungen/
// - attribution incl. a "fixthemap" link must stay visible
// - tiles are cached by the browser according to the server's Expires header
// - the URL can be overridden via "mapTileUrl" in config.json
const DEFAULT_TILE_URL = "https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png";

const TILE_ATTRIBUTION =
  'Daten © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>-Mitwirkende ' +
  '(<a href="https://opendatacommons.org/licenses/odbl/index.html" target="_blank" rel="noopener noreferrer">ODbL</a>), ' +
  '<a href="https://creativecommons.org/licenses/by-sa/2.0/" target="_blank" rel="noopener noreferrer">CC-BY-SA</a>, ' +
  '<a href="https://openstreetmap.org/fixthemap" target="_blank" rel="noopener noreferrer">mitmachen/Fehler melden</a>';

const ExoMap = ({ startCenter, positions = [], zoom = 15, className }) => {
  const theme = useTheme();
  const config = useConfig();
  // center of map
  const center = startCenter || [0, 0];
  const tileUrl = config?.mapTileUrl || DEFAULT_TILE_URL;

  // openstreetmap.de only offers a light style, so dark mode inverts the tiles
  const filter = {
    dark: "invert(1) hue-rotate(180deg) brightness(0.85) contrast(0.9) saturate(0.6)",
    light: "none",
  };

  return (
    <Box
      className={
        "flex absolute top-0 left-0 w-full h-full overflow-hidden " + className
      }
      sx={{
        "& .leaflet-control-zoom": {
          display: "none",
        },
        "& .leaflet-control-attribution.leaflet-control": {
          fontSize: "10px",
          background: "rgba(255, 255, 255, 0.8)",
          color: "#333",
          "& a": {
            color: "#0078A8",
          },
        },
        "& .leaflet-tile-container>img": {
          filter: filter[theme.palette.mode],
        },
      }}
    >
      <MapContainer
        doubleClickZoom={false}
        center={center}
        zoom={zoom}
        maxZoom={18}
        style={{ height: "100%", width: "100%", zIndex: "0" }}
      >
        <TileLayer url={tileUrl} attribution={TILE_ATTRIBUTION} />
        <LayerGroup>
          {positions.map((pos, index) => (
            <Location
              key={index}
              position={pos.position}
              type={pos.type || " default"}
            />
          ))}
        </LayerGroup>
      </MapContainer>
    </Box>
  );
};

const Location = ({ position, type }) => {
  return <CircleMarker center={position} />;
};

export default ExoMap;
